import { DialogActions, Stack, TextField, Typography } from "@mui/material";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import { styled } from "@mui/material/styles";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { addEnterprise } from "../../Redux/FAQSlice";
import "./Admin.css";
const ColorButton = styled(Button)(({ theme }) => ({
 //  color: theme.palette.getContrastText(purple[500]),
 backgroundColor: "white",
 color: "grey",
 border: "solid 1px grey",
 textTransform: "none",
 padding: "6px 30px",
 "&:hover": { backgroundColor: "#460073", color: "white" },
 "&:active": {
  backgroundColor: "#460073",
  color: "white",
 },
}));
const AddUserpopup = (props) => {
 const dispatch = useDispatch();
 const [usernmae, setUsername] = useState("");

 const handleClose = () => {
  props.setOpen(false);
 };
 const handleSubmission = () => {
  dispatch(addEnterprise(usernmae));
  handleClose();
 };
 const handleChange = (event) => {
  setUsername(event.target.value);
 };
 return (
  <React.Fragment>
   <Dialog
    open={props.open}
    onClose={handleClose}
    sx={{ minWidth: "1000px" }}
    className="view-more-dialog"
   >
    <IconButton
     aria-label="close"
     onClick={handleClose}
     sx={{
      position: "absolute",
      right: 8,
      top: 8,
     }}
    >
     {/* <CloseIcon /> */}
     <img src="images/FAQ/close icon.png" style={{ width: "20px" }}></img>
    </IconButton>
    <DialogContent sx={{ padding: "30px 48px" }}>
     <Stack alignItems={"center"} spacing={2} direction={"row"}>
      <Typography sx={{ fontWeight: "600" }}>Enter Enterprise ID</Typography>
      <TextField
       // label={`question ${qa.id}`}
       lebel="Enter Username"
       variant="outlined"
       multiline
       placeholder="xyex.abc"
       sx={{ borderColor: "#460073" }}
       fullWidth
       value={usernmae}
       onChange={handleChange}
      />
     </Stack>
    </DialogContent>
    <DialogActions
     sx={{ display: "flex", justifyContent: "center", padding: "0px 8px 35px 8px" }}
    >
     {" "}
     <ColorButton
      onClick={() => {
       handleSubmission();
      }}
     >
      Submit
     </ColorButton>
     <ColorButton onClick={handleClose}>Cancel</ColorButton>{" "}
    </DialogActions>
   </Dialog>
  </React.Fragment>
 );
};

export default AddUserpopup;
